import type { GuidedOrder } from '@/types/guidedOrder';

type EligibilityOrder = Pick<
  GuidedOrder,
  'status' | 'verified_prescription_id' | 'referring_practitioner_id'
> & {
  fulfillment_source?: string | null;
};

export function canPrescribeAgainstGuidedOrder(
  order: EligibilityOrder | null | undefined,
  myPractitionerId: string | null | undefined,
): boolean {
  if (!order || !myPractitionerId) return false;
  return (
    order.fulfillment_source === 'nimbus' &&
    order.status === 'mdi_completed' &&
    !order.verified_prescription_id &&
    order.referring_practitioner_id === myPractitionerId
  );
}
